class SubjectAreaService {
    constructor($http, $q) {
        let self = this;

        self.list = function() {
            return $http({
                method: 'GET',
                url: './api/subject_area',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.getById = function(id) {
            return $http({
                method: 'GET',
                url: './api/subject_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.save = function(area) {
            return $http.post('/api/subject_area/' + area.id, area, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.create = function(area) {
            return $http.post('/api/subject_area', area, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.delete = function(id) {
            return $http({
                method: 'DELETE',
                url: '/api/subject_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

    }
}

export default SubjectAreaService;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/subjectAreaService.js